import React, { useState, useEffect, useRef } from 'react';
//import { io } from 'socket.io-client';
//acceder al authContext
//import { authContext } from '../context/AuthContext';

const TelegramChat = ({ user, userId, socket, isSocketConnected }) => {
	const [roomName, setRoomName] = useState('');
	console.log("ROOMNAME", roomName)
	const [messages, setMessages] = useState([]);
	console.log("MESSAGES", messages)
	const [newMessage, setNewMessage] = useState('');
	const [isLoading, setIsLoading] = useState(true);
	const messagesEndRef = useRef(null);

	useEffect(() => {
		if(userId){
			setRoomName(`user_${userId}`);
		}
	}, []);

	useEffect(() => {
		if (socket && roomName) {
			socket.emit('joinRoom', roomName);
		}
	}, [roomName]);

	// Configurar listeners del socket
	useEffect(() => {
		if (!socket) return;


		const handleNewMessage = (message) => {
			console.log("ESCUCHANDO", message)
			setMessages(prev => [...prev, message]);
		};

		const handleMessageHistory = (history) => {
			setMessages(history);
			setIsLoading(false);
		};

		// Configurar event listeners
		if(roomName){
			console.log("ROOMNAME #45", roomName)
			//socket.emit('joinRoom', {room: roomName});
		}
		socket.on('new-message', handleNewMessage);
		socket.on('message_history', handleMessageHistory);

		// Solicitar historial cuando el socket esté conectado
		if (isSocketConnected) {
			//socket.emit('get_history');
			//socket.emit('joinRoom', roomName); //emite para unirse a la sala
			socket.emit('get_history');
		}

		// Cleanup listeners
		return () => {
			socket.off('new-message', handleNewMessage);
			socket.off('message_history', handleMessageHistory);
		};
	}, [socket, isSocketConnected]);

	// Scroll al último mensaje
	useEffect(() => {
		scrollToBottom();
	}, [messages]);

	const loadMessageHistory = async () => {
		try {
			const response = await fetch(`${process.env.REACT_APP_API_URL}/messages/history`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${localStorage.getItem('token')}`
				}
			});

			if (response.ok) {
				const data = await response.json();
				setMessages(data.messages);
			}
		} catch (error) {
			console.error('Error al cargar historial:', error);
		} finally {
			setIsLoading(false);
		}
	};


	const sendMessage = async (e) => {
		e.preventDefault();

		if (!newMessage.trim() || !isSocketConnected) return;

		const messageData = {
			message: newMessage.trim(),//antes text
			userId: userId,
			timestamp: new Date().toISOString()
		};

		try {
			// Enviar mensaje al servidor via HTTP
			const response = await fetch(`/api/messages/send`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${localStorage.getItem('token')}`
				},
				body: JSON.stringify(messageData)
			});

			if (response.ok) {
				setNewMessage('');
			} else {
				console.error('Error al enviar mensaje');
			}
		} catch (error) {
			console.error('Error:', error);
		}
	};

	const scrollToBottom = () => {
		messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
	};

	const formatTime = (timestamp) => {
		return new Date(timestamp).toLocaleTimeString('es-ES', {
			hour: '2-digit',
			minute: '2-digit'
		});
	};

	if (isLoading) {
		return (
			<div className="flex flex-col h-[500px] bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden">
				<div className="flex items-center justify-center h-full text-gray-500 dark:text-gray-400">
					Cargando mensajes...
				</div>
			</div>
		);
	}

	return (
		<div className="flex flex-col h-[500px] bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden">
			{/* Encabezado del chat */}
			<div className="p-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900">
				<div className="flex justify-between items-center">
					<div className="flex items-center space-x-2">
						<h3 className="text-lg font-semibold text-gray-900 dark:text-white">Soporte Telegram</h3>
						<span className={`inline-block w-2 h-2 rounded-full ${isSocketConnected ? 'bg-green-500' : 'bg-red-500'} mr-1`}></span>
						<span className="text-sm text-gray-600 dark:text-gray-400">
							{isSocketConnected ? 'Conectado' : 'Desconectado'}
						</span>
					</div>
					<div className="text-sm text-gray-500 dark:text-gray-400">
						Usuario: {user}
					</div>
				</div>
			</div>

			{/* Contenedor de mensajes */}
			<div className="flex-1 p-4 overflow-y-auto bg-white dark:bg-gray-800">
				{messages.length === 0 ? (
					<div className="flex items-center justify-center h-full">
						<p className="text-gray-500 dark:text-gray-400">No hay mensajes aún. ¡Envía un mensaje para comenzar!</p>
					</div>
				) : (
					<div className="space-y-3">
						{messages.map((message, index) => (
							<div
								key={index}
								className={`flex ${message.sender === 'user' || (message.sender === 'admin' || message.from_sender === 'admin') ? 'justify-end' : 'justify-start'}`}
							>
								<div className={`max-w-xs lg:max-w-md px-4 py-2 rounded-lg ${message.sender === 'user' || (message.sender === 'admin' || message.from_sender === 'admin') ? 'bg-blue-500 text-white' : 'bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-white'}`}>
									<p className="break-words">{message.message}</p>
									<div className={`text-xs mt-1 ${message.sender === 'user' || (message.sender === 'admin' || message.from_sender === 'admin') ? 'text-blue-100' : 'text-gray-500 dark:text-gray-400'}`}>
										{formatTime(message.timestamp)}
									</div>
								</div>
							</div>
						))}
						<div ref={messagesEndRef} />
					</div>
				)}
			</div>

			{/* Formulario de envío */}
			<form onSubmit={sendMessage} className="p-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900">
				<div className="flex items-center space-x-2">
					<textarea
						value={newMessage}
						onChange={(e) => setNewMessage(e.target.value)}
						placeholder="Escribe tu mensaje..."
						disabled={!isSocketConnected}
						maxLength={1000}
						className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
					/>
					<button
						type="submit"
						disabled={!newMessage.trim() || !isSocketConnected}
						className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
					>
						<span className="text-lg">➤</span>
					</button>
				</div>
			</form>
		</div>
	);
};

export default TelegramChat;